import axios from "axios";

export const BASE_URL = "https://api.faarsin.ir";
//export const BASE_URL = "https://devback.faarsin.ir";
export async function apiClient(endpoint, options = {}) {
    const url = `${BASE_URL}${endpoint}`;

    const {
        method = "GET",
        params,
        data,
        headers,
        ...rest
    } = options;

    const token = localStorage.getItem('access_token');
    const defaultHeaders = {
        "Content-Type": "application/json",
        ...(token && { "Authorization": `Bearer ${token}` }),
    };

    try {
        const response = await axios({
            url,
            method,
            params,
            data,
            headers: {
                ...defaultHeaders,
                ...headers,
            },
            ...rest,
        });

        return response.data;
    } catch (error) {
        let errorMessage = "خطای نامشخص در ارتباط API";
        let errorCode = error.status
        if (error.response) {
            let resData = error.response.data || {};

            // When responseType is 'blob', error.response.data will be a Blob.
            // We need to read the blob as text and parse it to extract error details.
            if (resData instanceof Blob) {
                try {
                    const blobText = await resData.text();
                    try {
                        resData = JSON.parse(blobText);
                    } catch {
                        // Not valid JSON – use the raw text
                        resData = blobText || {};
                    }
                } catch {
                    resData = {};
                }
            }

            if (resData.code === 'token_not_valid' || resData.detail === 'Given token not valid for any token type') {
                localStorage.removeItem('access_token');
                window.location.href = '/login/';
                throw new Error("نشست کاربری منقضی شده است.");
            } else if (resData.code === "subscription_inactive") {
                errorMessage = resData.detail;
                window.dispatchEvent(new CustomEvent('subscription_inactive', { detail: resData.detail }));
            }
            if (typeof resData === "string") {
                errorMessage = resData || `خطای HTTP: ${error.response.status}`;
            } else {
                let extractedError = resData.message || resData.error || resData.detail;
                if (!extractedError) {
                    if (resData.errors) {
                        extractedError = typeof resData.errors === 'string' ? resData.errors : JSON.stringify(resData.errors);
                    } else if (typeof resData === 'object' && Object.keys(resData).length > 0) {
                        try {
                            // Extract just the first value safely, and if it's nested continue extracting
                            let firstValue = Object.values(resData)[0];
                            if (Array.isArray(firstValue) && firstValue.length > 0) {
                                firstValue = firstValue[0];
                            }
                            
                            if (typeof firstValue === 'string') {
                                extractedError = firstValue;
                            } else if (typeof firstValue === 'object' && firstValue !== null) {
                                // Nested error like {"invoiceId": ["..."]}
                                const nestedValue = Object.values(firstValue)[0];
                                extractedError = Array.isArray(nestedValue) ? nestedValue[0] : JSON.stringify(firstValue);
                            } else {
                                extractedError = JSON.stringify(resData);
                            }
                        } catch (e) {
                            extractedError = `خطای HTTP: ${error.response.status}`;
                        }
                    }
                }
                errorMessage = extractedError || `خطای HTTP: ${error.response.status}`;
            }
        } else if (error.request) {
            errorMessage = "خطای شبکه: سرور پاسخ نداد.";
        } else {
            errorMessage = error.message;
        }
        console.log(errorMessage, errorCode)
        const err =  new Error(errorMessage);
        err.statusCode = errorCode
        throw err;
    }
}
